<template>
    <header>
        <div class="container">
            <router-link to="/">
                <h1>To-Do-List</h1>
            </router-link>
        </div>
    </header>
</template>

<style scoped lang="scss">
@import '../assets/scss/common/header.scss';
</style>